import React from "react";
import {
  Grid,
  Modal,
  FormGroup,
  ToggleButtonGroup,
  Radio,
  Button
} from "react-bootstrap";
import { HashLink as Link } from "react-router-hash-link";
import profileModal from "./profileModal.css";
/**
 * @desc model content according to status condition
 * @param props
 * @return model content
 */
const CandidateStatus = props => {
  if (props.status == "REGRET") {
    return (
      <div className="regret-popup">
        <h4>
          The candidate will be <span className="red">regretted</span>.
        </h4>
        <h4>Please choose a reason for your decision:</h4>
        <FormGroup className="regret-reason" onChange={props.handleChange}>
          <Radio className="options" value={1} name="rBG" defaultChecked>
            <div className="check" />Does not meet expectation of skills
          </Radio>
          <Radio className="options" value={2} name="rBG">
            <div className="check" />Does not meet expectation of experience
          </Radio>
          <Radio className="options" value={3} name="rBG">
            <div className="check" />Other
          </Radio>
        </FormGroup>
        <Button
          bsStyle="primary"
          onClick={() => props.updateCandidateStatus("REGRET")}
        >
          Continue
        </Button>
      </div>
    );
  } else if (props.status == "PROGRESS" && props.progressCount === 0) {
    return (
      <div className="progress-popup">
        <h4>
          The candidate has been <span className="green">progressed</span>.
        </h4>
        <h4>
          Once all candidates have been reviewed please send to your recruiter.
        </h4>
        <Link to="/">
          <Button bsStyle="primary" onClick={props.close}>
            Done
          </Button>
        </Link>
      </div>
    );
  } else if (props.status == "" && props.showModal) {
    return (
      <div className="final-popup">
        <h4>All candidates have been categorised.</h4>
        <h4>Please review all and then send to your recruiter.</h4>
        <Link to="/talentpool/review">
          <Button bsStyle="primary">Review all</Button>
        </Link>
      </div>
    );
  } else {
    return null;
  }
};
/**
 * @desc Profile Regret/Progress/completed model pop-up
 * @param props
 * @return  content
 */
const ProfileModal = props => {
  return (
    <Modal
      show={
        props.showModal !== "" && props.status !== "already"
          ? props.showModal
          : false
      }
      className={
        props.status === "" ? "profile-modal final-pop" : "profile-modal"
      }
      bsSize="large"
    >
      <Modal.Body>
        <div className="no-cont">
          <div className="line" />
          <span className="cont-a">
            <span className="no-a">1</span>
            <p>Decision</p>
          </span>
          <span className="cont-a dis">
            <span className="no-a">2</span>
            <p>Review All</p>
          </span>
        </div>
        <CandidateStatus
          status={props.status}
          showModal={props.showModal}
          progressCount={props.progressCount}
          close={props.close}
          updateCandidateStatus={() => props.updateCandidateStatus("REGRET")}
          handleChange={props.handleChange}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ProfileModal;



// WEBPACK FOOTER //
// ./src/components/Client/ProfileModal/ProfileModal.js